import {useEffect, useState} from "react";
import SimCardRechargeStyle from "./SimCardRechargeStyle";
import {Helmet} from "react-helmet";
import Box from "../../../components/box/Box";
import axios from "../../../components/plugins/axios";
import {DropdownButton} from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown'
import InternetChargePaymentModal from "../../../components/payment/InterentChargePaymentModal";
import {getOperatorBgColor, getOperatorEnName, getProduct, operatorsPrefix} from "../../../components/payment/util";
import {getBahabinText, toPersianNumber} from "../../../util/DominantUtil";


function getType(operator) {
    if (operator === 'ایرانسل') {
        return '5'
    } else if (operator === 'همراه اول') {
        return '6'
    } else if (operator === 'رایتل') {
        return '7';
    }
    return '';

}

export default function SimCardReCharge(response) {
    const [packages, setPackages] = useState(null);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [price, setPrice] = useState(null);
    const [profileId, setProfileId] = useState(null);
    const [operator, setOperator] = useState(null);
    const [pType, setPType] = useState('دائمی');
    const [pTypes, setPTypes] = useState(null);
    const [pPeriods, setPPeriods] = useState(null);
    const [pPeriod, setPeriod] = useState('همه');
    const [pName, setPName] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setPackages(getPackages());
    }, [])

    function extractPeriods() {
        let arr = ['همه'];
        packages
            .filter(p => p.operator === operator)
            .map(x => x.kind)
            .flatMap(x => x)
            .filter(o => o.name === pType)
            .map(x => x.time)
            .flatMap(x => x)
            .map(x => x.name)
            .forEach(x => arr.push(x));
        setPPeriods(arr);
    }

    function setTypes() {
        setPTypes(packages
            .filter(p => p.operator === operator)
            .map(x => x.kind)
            .flatMap(x => x)
            .map(x => x.name));
    }

    useEffect(() => {
        setPrice(null);
        if (operator && packages) {
            setTypes();
            extractPeriods();
        }
        if (operator) {
            setPeriod('همه');
            setPType('دائمی');
        }
    }, [operator])

    function getPackages() {
        axios
            .get("/sim-internet-packages").then((response) => {
            setPackages(response.data)
        }).catch((error) => {
            console.log(error)
        });
    }

    function getOperator(opFaName) {
        return <div className="col-sm-3" onClick={() => setOperator(opFaName)}>
            <div className={`operator bg-gray-300 h-14 w-14 rounded-custom mx-auto ${getOperatorEnName(opFaName)}`}
                 style={{backgroundColor: operator === opFaName ? getOperatorBgColor(operator) : ''}}>
                <img src={`/images/sim-card-recharge/${getOperatorEnName(opFaName)}.png`} alt="Irancel"/>
            </div>
            <p className={`text-center text-sm pt-0.5 ${operator === opFaName ? '' : 'text-gray-500'}`}>{opFaName}</p>
        </div>;
    }

    function getCard(idx, p) {
        return <div className="col p-0 card-box">
            <div
                className={`py-2.5 px-2.5 rounded-custom price-box mb-1.5 mt-0 ${idx % 2 === 0 && 'ml-1.5'}
                    ${price === p.price && 'price-box-selected'}`}
                onClick={() => {
                    setPrice(p.price);
                    setProfileId(p.profile_id);
                    setPName(p.name);
                }}>
                <div className="grid grid-cols-2">
                    <div className="text-right">
                        <span className="text-base"
                              style={{color: price === p ? "#fff" : "rgb(44, 53, 68)"}}>{toPersianNumber(p.category_name)}</span>
                    </div>
                    <div className="text-left">
                        <span className="text-base">{toPersianNumber(p.price.toLocaleString())}</span>
                        <span className="text-gray-400 pr-1 text-sm">ریال</span>
                    </div>
                </div>
                <div className="py-2"><p className="text-center text-base"
                                         style={{color: price === p ? "rgba(255,255,255,0.7)" : "#6e798d"}}>{toPersianNumber(p.name)}</p>
                </div>
            </div>
        </div>;
    }

    function getPType(x) {
        return x === pType ?
            <Dropdown.Item eventKey={x} active>{x}</Dropdown.Item> :
            <Dropdown.Item eventKey={x}>{x}</Dropdown.Item>;
    }

    function getPackagePeriod(x) {
        return x === pPeriod ?
            <Dropdown.Item eventKey={x} active>{x}</Dropdown.Item> :
            <Dropdown.Item eventKey={x}>{x}</Dropdown.Item>;
    }

    function getAllCards() {
        return operator && packages && packages
            .filter(p => p.operator === operator)
            .map(x => x.kind)
            .flatMap(x => x)
            .filter(x => x.name === pType)
            .map(p => p.time)
            .flatMap(p => p)
            .flatMap(p => p.packages)
            .sort((a,b) => compare(a.price, b.price))
            .map((p, idx) => getCard(idx, p));
    }

    function compare(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }

    function getFilteredCards() {
        return operator && packages && packages
            .filter(p => p.operator === operator)
            .map(x => x.kind)
            .flatMap(x => x)
            .filter(x => x.name === pType)
            .map(p => p.time)
            .flatMap(p => p)
            .filter(x => x.name == pPeriod)
            .flatMap(p => p)
            .flatMap(x => x.packages)
            .sort((a,b) => compare(a.price, b.price))
            .map((p, idx) => getCard(idx, p));
    }

    return (
        <Box rwFreeHeight={true} disableHeader={true} loaded={true} leftBoxClassName={'w-100 pt-4'}
             disableAdBox={true}
             linksMap={{
                 'last': 'بسته اینترنت',
             }}>
            <Helmet
                title={`خرید بسته اینترنت همراه: ایرانسل، همراه اول و رایتل ${getBahabinText()}`}
            />
            <h1 className="text-center text-xl">خرید بسته اینترنت همراه: ایرانسل، همراه اول و رایتل</h1>
            <div className="container-fluid pt-4">
                <div className="">
                    <div className="row box-shadow bg-white rounded-custom p-4 mb-2">
                        <div className="col-sm pt-3">
                            <div className="row row-cols-2 rounded-custom">
                                <label className="col-2 col-form-label mt-2 text-right">شماره:</label>
                                <div className="col-10">
                                    <input autoFocus placeholder="09xxxxxxxxx" type="number" maxLength={11}
                                           className="form-control h-14 rounded-custom text-left" onChange={(val) => {
                                        let v = val.target.value;
                                        const reg = /^09[0-9]{9}$/;
                                        if (reg.test(v))
                                            setMobileNumber(v);

                                        const prefix = v.substr(0, 4);
                                        operatorsPrefix.forEach(x => {
                                            const data = new Set(x.items);
                                            if (data.has(prefix)) {
                                                setOperator(x.operator);
                                            }
                                        });
                                        // operatorsPrefix[operator].contain(prefix);
                                    }}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm pt-3">
                            <div className="row row-cols-3 justify-content-center">
                                {getOperator('ایرانسل')}
                                {getOperator('همراه اول')}
                                {getOperator('رایتل')}
                            </div>
                        </div>
                    </div>
                    <div className="mb-2">
                        <div className="row bg-white box-shadow rounded-custom h-16 text-center">
                            <div className="col-6 grid grid-cols-2">
                                <div className="pt-3">
                                    <span>نوع:</span>
                                </div>
                                <div className="pt-2.5">
                                    <DropdownButton onSelect={(x) => setPType(x)} title={pType}>
                                        {pTypes && pTypes.map(x => getPType(x))}
                                    </DropdownButton>
                                </div>
                            </div>
                            <div className="col-6 text-center bg-white rounded-custom h-16">
                                <div className="grid grid-cols-2">
                                    <div className="pt-3">
                                        <span>مدت:</span>
                                    </div>
                                    <div className="pt-2.5">
                                        <DropdownButton onSelect={(x) => setPeriod(x)} title={pPeriod}>
                                            {pPeriods && pPeriods.map(x => getPackagePeriod(x))}
                                        </DropdownButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="row row-cols-1 row-cols-sm-2 justify-content-center text-center">
                            {pPeriod === 'همه' ? getAllCards() : getFilteredCards()}
                            <div className="h-14"/>
                        </div>

                        {price && mobileNumber && operator && profileId &&
                        <div>
                            <div className="row justify-content-center h-14 fixed-bottom">
                                <div
                                    className="h-auto btn btn-success rounded-custom text-lg max-w-6xl buy-btn w-100 mb-1 mx-auto pt-3"
                                    onClick={() => setShowModal(true)}>
                                    خرید

                                </div>
                            </div>
                        </div>
                        }
                    </div>

                </div>
                {price && mobileNumber && operator && showModal &&
                <InternetChargePaymentModal show={showModal} onHide={() => setShowModal(false)} operator={operator}
                                            mobileNumber={mobileNumber}
                                            pType={pType}
                                            profileId={profileId}
                                            pName={pName}
                                            type={getType(operator)}
                                            price={price} onClick={() => setShowModal(false)}
                                            enName={getOperatorEnName(operator)}
                                            product={getProduct(operator)}/>
                }
            </div>
            <SimCardRechargeStyle/>
        </Box>
    );
}